<template>
  <app-header />

  <v-main>
    <slot />
  </v-main>

  <app-footer />
</template>

<script>
  export default {
    name      : 'DefaultLayout',
    components: {},
    props     : {},
    data () {
      return {}
    },
    computed: {},
    watch   : {},
    created () {},
    mounted () {},
    beforeUnmount () {},
    unmounted () {},
    methods : {}
  }
</script>

<style scoped>

</style>
